import * as React from 'react';
import { withLocalize, LocalizeContextProps } from "react-localize-redux";
import bindAllOfThis from 'src/utils/BindThisHelper';
import { Row, Col } from "antd";
import DialogBox from "src/components/mission/DialogBox";
import { EnhancedProps } from 'src/pages/student/models/props';
import DebugUtil from "src/utils/DebugUtil";
import VideoPlayer, { SubtitleConfig } from "src/components/common/VideoPlayer";
import VideoTranslations from "src/constants/VideoTranslations";
import UserApiController from 'src/api/UserApiController';

export interface StudentVideoProps extends EnhancedProps, LocalizeContextProps {
}

interface StudentVideoState {
    hasFinished: boolean;
    hasWatched: boolean;
}

class StudentVideo extends React.Component<StudentVideoProps, StudentVideoState> {
    constructor(props: StudentVideoProps) {
        super(props);
        bindAllOfThis(this, StudentVideo.prototype);

        this.state = {
            hasFinished: DebugUtil.isDebugEnabled(),
            hasWatched: false
        };
    }

    componentDidMount(): void {
        document.addEventListener("keydown", this.handleKeyPress, false);
    }

    componentWillUnmount() {
        // Remove the event when we change pages
        document.removeEventListener("keydown", this.handleKeyPress, false);
    }

    handleKeyPress(event): void {
        if (event.key === "ArrowRight") {
            if (this.hasNextButton()) {
                this.onNext();
            }
        }
        else if (event.key === "ArrowLeft") {
            if (this.hasBackButton()) {
                this.onBack();
            }
        }
    }

    hasNextButton(): boolean {
        return this.state.hasFinished;
    }

    hasBackButton(): boolean {
        return true;
    }

    onNext() {
        this.props.onNext();
    }

    onBack() {
        this.props.onBack();
    }

    onEnd() {
        if (DebugUtil.isDebugEnabled()) {
            console.warn("Finished!"); // JB - Remove this console.warn
        }

        // Mark the video as watched once
        if (!this.state.hasWatched) {
            UserApiController.markVideoWatched({ gradeId: this.props.User.gradeId, planetId: this.props.currentPlanet.id });
        }

        this.setState({
            hasFinished: true,
            hasWatched: true
        });
    }

    render() {
        let planetCode: string = (this.props.currentPlanet || { name: "" }).name.toLowerCase() as string;

        let terrainClassName = `planet-terrain planet-terrain-${planetCode}`;
        let podClassName = `star-pod star-pod-landed star-pod-${planetCode}-landed`;
        let pilotClassName = `star-pilot star-pilot-${planetCode}`;

        let videoTranslation = VideoTranslations.FindByGradePlanetAndLanguage(this.props.currentGrade, this.props.currentPlanet, this.props.activeLanguage.code);
        let subtitles: SubtitleConfig[] = [];
        if (videoTranslation.subtitleUrl != null && videoTranslation.subtitleUrl.length > 0) {
            subtitles = [
                { src: videoTranslation.subtitleUrl, label: "English", srcLang: "en-US" }
            ];
        }
        this.props.onChangeAudio("");

        return <div>
            <Row>
                <Col className="dialog-content video-wrapper" xs={{ span: 22, push: 1 }} md={{ span: 16 }} lg={16} xl={14}>
                    <Row>
                        <DialogBox
                            currentGrade={this.props.currentGrade}
                            currentPlanet={this.props.currentPlanet}
                            buttonNextType={this.hasNextButton() ? "arrow" : "none"}
                            buttonBackType={this.hasBackButton() ? "arrow" : "none"}
                            onBack={this.onBack}
                            onNext={this.onNext}>
                            <VideoPlayer
                                key="videoPlayerKey"
                                src={videoTranslation.videoUrl}
                                subtitles={subtitles}
                                playing={true}
                                controls={true}
                                width={"100%"}
                                height={"100%"}
                                muted={!this.props.Config.audioEnabled}
                                onEnded={this.onEnd}
                            />
                        </DialogBox>
                    </Row>
                </Col>
            </Row>
            <div className={pilotClassName} />
            <div className={podClassName} />
            <div className={terrainClassName} />
        </div>;
    }
}

export default withLocalize(StudentVideo);



// WEBPACK FOOTER //
// ./src/pages/student/scenes/StudentVideo.tsx